import { saveNewContract, SAVE_NEW_CONTRACT, verifySmsCode, VERIFY_SMS_CODE, SEND_SMS, sendSms, GET_PROJECT_PROPERTIES, getProjectProperties, GET_ATTRIBUTES, getAttributes } from './actions';
import { takeLatest } from 'redux-saga/effects';

export default [
    takeLatest(SAVE_NEW_CONTRACT, saveNewContract),
    takeLatest(VERIFY_SMS_CODE, verifySmsCode),
    takeLatest(SEND_SMS, sendSms),
    takeLatest(GET_PROJECT_PROPERTIES, getProjectProperties),
    takeLatest(GET_ATTRIBUTES, getAttributes),
];
